import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { all_routes } from "../router/all_routes";
import ImageWithBasePath from "../../core/data/img/ImageWithBasePath";

const Header = () => {
  const routes = all_routes;
  const location = useLocation();

  useEffect(() => {
    document.body.classList.remove("menu-opened");
  }, [location.pathname]);

  const header = [
    {
      tittle: "Home",
      showAsTab: false,
      separateRoute: true,
      routes: routes.home,
      hasSubRoute: false,
      showSubRoute: false,
    },
    {
      tittle: "Services",
      showAsTab: false,
      separateRoute: true,
      routes: routes.services,
      hasSubRoute: false,
      showSubRoute: false,
    },
    {
      tittle: "About Us",
      showAsTab: false,
      separateRoute: true,
      routes: routes.aboutus,
      hasSubRoute: false,
      showSubRoute: false,
    },
    {
      tittle: "Contact Us",
      showAsTab: false,
      separateRoute: true,
      routes: routes.contact,
      hasSubRoute: false,
      showSubRoute: false,
    },
  ];

  return (
    <>
      <header className="header">
        <div className="container-fluid">
          <nav className="navbar navbar-expand-lg header-nav">
            <div className="navbar-header">
              <Link 
                id="mobile_btn" 
                to="#" 
                onClick={(e) => { 
                  e.preventDefault(); 
                  document.body.classList.toggle("menu-opened"); 
                }}
              >
                <span className="bar-icon">
                  <span />
                  <span />
                  <span />
                </span>
              </Link>
              <Link to={routes.home} className="navbar-brand logo">
                <ImageWithBasePath
                  src="assets/img/logo.svg"
                  className="img-fluid"
                  alt="Logo"
                />
              </Link>
              <Link to={routes.home} className="navbar-brand logo-small">
                <ImageWithBasePath
                  src="assets/img/logo-small.png"
                  className="img-fluid"
                  alt="Logo"
                />
              </Link>
            </div>
            <div className="main-menu-wrapper">
              <div className="menu-header">
                <Link to={routes.home} className="menu-logo">
                  <ImageWithBasePath
                    src="assets/img/logo.svg"
                    className="img-fluid"
                    alt="Logo"
                  />
                </Link>
                <Link 
                  id="menu_close" 
                  className="menu-close" 
                  to="#" 
                  onClick={(e) => { 
                    e.preventDefault(); 
                    document.body.classList.remove("menu-opened"); 
                  }}
                >
                  <i className="fas fa-times" />
                </Link>
              </div>
              <ul className="main-nav">
                {header.map((mainMenus, mainIndex) => (
                  <li
                    key={mainIndex}
                    className={
                      location.pathname.includes(mainMenus.routes || "")
                        ? "active"
                        : ""
                    }
                  >
                    <Link to={mainMenus.routes}>{mainMenus.tittle}</Link>
                  </li>
                ))}
              </ul>
            </div>
            {/* <ul className="nav header-navbar-rht">
              <li className="nav-item">
                <Link className="nav-link header-login" to={routes.login}>
                  <span>
                    <i className="fa-regular fa-user" />
                  </span>
                  Sign In
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link header-reg" to={routes.signup}>
                  <span>
                    <i className="fa-solid fa-lock" />
                  </span>
                  Sign Up
                </Link>
              </li>
            </ul> */}
          </nav>
        </div>
      </header>
    </>
  );
};

export default Header;
